export const qualifierWizardForm = 'qualifierWizard';